module.exports = __webpack_public_path__ + "img/role_2_name.4bfb807e.png";